import { createSelector } from '@reduxjs/toolkit';

import { selectAdditionalPhone, selectMobilePhone, selectWorkplaceInfoData } from 'entities/creditForm';

// в форму добавляем номер телефона, чтобы он был доступен при валидации
export const formDataSelector = createSelector(
  [selectWorkplaceInfoData, selectMobilePhone, selectAdditionalPhone],
  (additionalData, mobilePhone, additionalPhone) => {
    return {
      ...additionalData,
      mobilePhone,
      additionalPhone,
    };
  },
);
